export interface Integer {
  min: number | bigint
  max: number | bigint
  precision: number
}
export const integerDict: { [key: string]: Integer } = {
  int8: {
    min: -128,
    max: 127,
    precision: 0
  },
  uint8: {
    min: 0,
    max: 255,
    precision: 0
  },
  int16: {
    min: -32768,
    max: 32767,
    precision: 0
  },
  uint16: {
    min: 0,
    max: 65535,
    precision: 0
  },
  int32: {
    min: -2147483648,
    max: 2147483647,
    precision: 0
  },
  uint32: {
    min: 0,
    max: 4294967295,
    precision: 0
  },
  int64: {
    min: BigInt(-9223372036854775808n),
    max: BigInt(9223372036854775807n),
    precision: 0
  },
  uint64: {
    min: 0,
    max: BigInt(18446744073709551615n),
    precision: 0
  }
}
